module.exports = __webpack_public_path__ + "img/033.b013ac7a.jpeg";